import React from "react";

interface Props {
  color?: string;
  size?: number;
}

const TicketIdIcon = ({ color = "#79808A", size = 24 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6126 17V11.897H14.3756V17H13.6126ZM15.6155 17V11.897H17.6805C19.1505 11.897 19.9905 12.919 19.9905 14.452C19.9905 15.985 19.1505 17 17.6805 17H15.6155ZM16.3785 16.342H17.5685C18.5555 16.342 19.2065 15.733 19.2065 14.438C19.2065 13.143 18.5485 12.555 17.5685 12.555H16.3785V16.342Z"
        fill={color}
      />
      <path
        d="M4.39209 9.55565H4.78759M6.36961 9.55565H6.76511M8.34713 9.55565H8.74263M10.3246 9.55565H10.7202M7.95162 13.9366V11.3811M9.13814 13.9366V12.4763M3.99658 15.9446C3.99658 16.2469 4.26236 16.4922 4.58984 16.4922H6.18557C6.32424 16.2699 6.52395 16.0852 6.76456 15.9568C7.00517 15.8284 7.27819 15.7608 7.55612 15.7608C7.83405 15.7608 8.10707 15.8284 8.34768 15.9568C8.58829 16.0852 8.788 16.2699 8.92667 16.4922H10.5224C10.8499 16.4922 11.1157 16.2469 11.1157 15.9446V7.54771C11.1157 7.24542 10.8499 7.00009 10.5224 7.00009H8.92667C8.788 7.22242 8.58829 7.40709 8.34768 7.5355C8.10707 7.66391 7.83405 7.73152 7.55612 7.73152C7.27819 7.73152 7.00517 7.66391 6.76456 7.5355C6.52395 7.40709 6.32424 7.22242 6.18557 7.00009H4.58984C4.26236 7.00009 3.99658 7.24542 3.99658 7.54771V15.9446Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TicketIdIcon;
